// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@bg/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.addPriceBreakLink = linkIconStyleGenerator(
    "AddToList",
    "13px",
    14,
    "font-size: 15px; line-height: 20px; font-weight: 500; color: #131313 !important;",
    "color: #9C822F;",
    "margin-top: 10px",
);

rfqQuoteDetailsQuoteLineCalculatorStyles.resetButton = {
    css: css`
        @media (max-width: 481px) {
            text-align: center;
            margin: 0 !important;
            margin-top: 10px;
        }
    `,
    typographyProps: {
        css: css`
            @media (max-width: 481px) {
                width: 100%;
                text-align: center;
            }
        `,
    },
};
